module.exports = "import React from 'react';\nimport { Split, SplitItem } from '@patternfly/react-core';\n\nclass SplitWithGutter extends React.Component {\n  render() {\n    return (\n      <Split gutter=\"md\">\n        <SplitItem>Secondary content</SplitItem>\n        <SplitItem isMain>Primary Content</SplitItem>\n        <SplitItem>Secondary content</SplitItem>\n      </Split>\n    );\n  }\n}\n\nexport default SplitWithGutter;\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/raw-loader!../react-core/src/layouts/Split/examples/SplitWithGutter.js
// module id = 466
// module chunks = 114276838955818 182305654616262